<div class="custom-search-container" [class.focused]="isFocused">
  <div class="custom-search-wrapper">
    <input
      type="text"
      [placeholder]="placeholder"
      [value]="value"
      [disabled]="disabled"
      [style.color]="textColor"
      [style.background-color]="backgroundColor"
      (input)="onInput($event)"
      (keyup)="onKeyup($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (keyup.enter)="onEnter()"
      class="custom-search-input">
    <div class="custom-search-icon" [style.color]="iconColor">
      <svg class="search-svg" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
      </svg>
    </div>
    @if (showClearButton && value) {
      <button
        type="button"
        class="custom-search-clear"
        (click)="clearSearch()"
        [style.color]="iconColor">
        <svg class="clear-svg" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    }
  </div>
</div>
